import { apiSliceV2 } from "../../apiSlice";

export const energyInitiativesApiSlice = apiSliceV2.injectEndpoints({
    tagTypes: ["EnergyInitiative"],
    endpoints: (builder) => ({
        getEnergyInitiativesById: builder.query({
            query: ({ accountId, energyInitiativeId }) => ({
                url: `/EnergyInitiatives/${energyInitiativeId}`,
                headers: {
                    'X-Account-Id': accountId,
                },
            }),
            providesTags: ["EnergyInitiative"],
        }),
        postEnergyInitiative: builder.mutation({
            query: ({accountId, energyInitiative}) => ({
                url: `/EnergyInitiatives`,
                method: 'POST',
                body: energyInitiative,
                headers: {
                    'X-Account-Id': accountId,
                },
            }),
            invalidatesTags: ["EnergyInitiative", "EnergyGroup"],
        }),
        putEnergyInitiative: builder.mutation({
            query: ({ accountId, energyInitiativeId, updates }) => ({
                url: `/EnergyInitiatives/${energyInitiativeId}`,
                method: 'PUT',
                body: updates,
                headers: {
                    'X-Account-Id': accountId,
                },
            }),
            invalidatesTags: ["EnergyInitiative", "EnergyGroup"],
        }),
        deleteEnergyInitiative: builder.mutation({
            query: ({ accountId, energyInitiativeId }) => ({
                url: `/EnergyInitiatives/${energyInitiativeId}`,
                method: 'DELETE',
                headers: {
                    'X-Account-Id': accountId,
                },
            }),
            invalidatesTags: ["EnergyInitiative", "EnergyGroup"],
        }),
    }),
});

export const {
    useGetEnergyInitiativesByIdQuery,
    useLazyGetEnergyInitiativesByIdQuery,
    usePostEnergyInitiativeMutation,
    usePutEnergyInitiativeMutation,
    useDeleteEnergyInitiativeMutation,
} = energyInitiativesApiSlice;